import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { parse } from 'qs';
import Detect from 'mobile-detect';
import { Trans, withTranslation } from 'react-i18next';
import { Button } from '../../../../common/components/button';
import Alert from '../../../../common/components/alert';
import confirmPasswordReset from '../../actions/confirm-password-reset';

class ConfirmPasswordResetContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      success: false,
      error: null,
      isMobileClient: false,
    };

    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleResend = this.handleResend.bind(this);
  }

  componentDidMount() {
    const device = new Detect(window.navigator.userAgent || '');

    // App webviews have no dashboard session to return to.
    if (device.phone()) this.setState({ isMobileClient: true });
  }

  getToken() {
    const query = parse(this.props.location.search, { ignoreQueryPrefix: true });

    return query.token || '';
  }

  handleResend() {
    this.props.history.push('/auth/forgot');
  }

  async handleConfirm(event) {
    event?.preventDefault?.();

    const { dispatch, t } = this.props;
    const token = this.getToken();

    if (!token || this.state.submitting || this.state.success) return;

    this.setState({ submitting: true, error: null });

    try {
      const { success } = await dispatch(confirmPasswordReset(token));

      if (success) {
        this.setState({ submitting: false, success: true });

        return;
      }

      this.setState({
        submitting: false,
        error: t('authentication:confirm_password_reset_invalid'),
      });
    } catch (_err) {
      this.setState({
        submitting: false,
        error: t('authentication:confirm_password_reset_invalid'),
      });
    }
  }

  render() {
    const { submitting, success, error, isMobileClient } = this.state;
    const hasToken = !!this.getToken();
    const showResend = !success && (!hasToken || !!error);

    return (
      <>
        <h2><Trans i18nKey="authentication:confirm_password_reset_header" /></h2>
        <div className="Authentication__Form__Description">
          <Trans i18nKey="authentication:confirm_password_reset_explanation" />
        </div>

        <form className="Form" onSubmit={this.handleConfirm}>
          {success ? (
            <Alert type="success" className="tw-mb-4">
              <Trans i18nKey="authentication:confirm_password_reset_success" />
            </Alert>
          ) : null}

          {error || !hasToken ? (
            <Alert type="warning" className="tw-mb-4">
              <Trans i18nKey="authentication:confirm_password_reset_invalid" />
            </Alert>
          ) : null}

          {showResend ? (
            <Button type="primary" size="fill" onClick={this.handleResend}>
              <Trans i18nKey="authentication:confirm_password_reset_resend" />
            </Button>
          ) : !success ? (
            <Button
              type="primary"
              size="fill"
              isLoading={submitting}
              disabled={submitting}
              buttonType="submit"
            >
              <Trans i18nKey="authentication:confirm_password_reset_submit" />
            </Button>
          ) : null}

          {!isMobileClient ? (
            <div className="Authentication__Form__Action">
              <Link to="/auth/login">
                <Trans i18nKey="authentication:confirm_password_reset_back" />
              </Link>
            </div>
          ) : null}
        </form>
      </>
    );
  }
}

export default connect()(withTranslation()(ConfirmPasswordResetContainer));
